import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';
import moment from 'moment';

export const LOYAL_CHILDREN_REPORT_REQUEST = 'LOYAL_CHILDREN_REPORT_REQUEST';
export const LOYAL_CHILDREN_REPORT_SUCCESS = 'LOYAL_CHILDREN_REPORT_SUCCESS';
export const LOYAL_CHILDREN_REPORT_FAILURE = 'LOYAL_CHILDREN_REPORT_FAILURE';

export const LOYAL_CHILDREN_EXPORT_REQUEST = 'LOYAL_CHILDREN_EXPORT_REQUEST';
export const LOYAL_CHILDREN_EXPORT_SUCCESS = 'LOYAL_CHILDREN_EXPORT_SUCCESS';
export const LOYAL_CHILDREN_EXPORT_FAILURE = 'LOYAL_CHILDREN_EXPORT_FAILURE';

export const loadLoyalChildrenReport = (options) => ({
	[CALL_API]: {
		types: [LOYAL_CHILDREN_REPORT_REQUEST, LOYAL_CHILDREN_REPORT_SUCCESS, LOYAL_CHILDREN_REPORT_FAILURE],
		endpoint: `api/reports/loyalChildren`,
		request: options,
		schema: Schemas.LOYAL_CHILDREN_REPORT_ARRAY
	}
});

export const exportLoyalChildren = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [LOYAL_CHILDREN_EXPORT_REQUEST, LOYAL_CHILDREN_EXPORT_SUCCESS, LOYAL_CHILDREN_EXPORT_FAILURE],
			endpoint: `api/reports/loyalChildren/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `LoyalChildrenReport-${moment().format('YYYY-MM-DD')}.xlsx`
	});
}